/**
 * @author       jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright    Copyright (c) 2021, Zumper
 */

import { payloadReducer } from '@zcode/reducers'
import { combineReducers } from 'redux'
import { handleAction } from 'redux-actions'
import { SET_RENTER_QUESTIONS } from '../constants/index'

export const renterQuestionsReducer = combineReducers({
  renterQuestions: handleAction(SET_RENTER_QUESTIONS, payloadReducer, []),
})
